import React, { FunctionComponent as FC, useState, useContext } from "react";
import { FunnelContext } from "@components/funnel/builder/FunnelContext";

import P from "@atoms/Typography/Text";
import Button from "@components/migratedComponents/molecules/Button";
import Input from "@molecules/Input";

import { useForm } from "react-hook-form";
import { useAlert } from "react-alert";
import { useMutation } from "react-query";
import {
  IUpdateLocationParams,
  updateLocation,
} from "@components/funnel/hooks/useLocationUpdate";
import SettingCard from "@molecules/SettingCard";
import { $EmailWrapper } from "./BusinessEmail.sc";

const BusinessEmail: FC = () => {
  const [editing, setEditing] = useState(false);
  const [updatingEmail, setUpdatingEmail] = useState(false);
  const alert = useAlert();
  const { funnelData, updateFrontend } = useContext(FunnelContext);

  const { handleSubmit, register, errors } = useForm({
    mode: "onChange",
  });

  const mutation = useMutation((params: IUpdateLocationParams) =>
    updateLocation(params)
  );

  const submitLocationUpdates = async (params) => {
    setUpdatingEmail(true);
    mutation.mutate(params, {
      onSuccess: (responseData) => {
        setEditing(false);
        setUpdatingEmail(false);
        funnelData.backend.location_attributes = responseData;
        updateFrontend();
        alert.success(<p>Save was successful</p>);
      },
      onError: () => {
        setUpdatingEmail(false);
        alert.error(
          <>
            <h3>Something went wrong.</h3>
            <p>Please try again later.</p>
          </>
        );
      },
    });
  };

  return (
    <SettingCard
      onClick={() => {
        setEditing(true);
      }}
      onOutsideClick={() => {
        setEditing(false);
      }}
    >
      <P size="3" color="baseDark" fontWeight={600}>
        EMAIL
      </P>
      {editing ? (
        <form onSubmit={handleSubmit(submitLocationUpdates)}>
          <Input
            id="uuid"
            name="uuid"
            type="hidden"
            register={register()}
            value={funnelData.backend.location_attributes.uuid}
          />
          <Input
            name="email"
            register={register({
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Please enter a valid email address.",
              },
            })}
            errors={errors.email}
            defaultValue={funnelData.backend.location_attributes.email}
          />
          <Button
            color="primary"
            type="submit"
            onClick={null}
            leftIcon={updatingEmail ? "spinner" : null}
          >
            Save
          </Button>
        </form>
      ) : (
        funnelData.backend.location_attributes.email && (
          <$EmailWrapper>
            <P size="2" color="baseDarkest" margin="8px 0px 0px 0px">
              {funnelData.backend.location_attributes.email}
            </P>
          </$EmailWrapper>
        )
      )}
    </SettingCard>
  );
};

export default BusinessEmail;
